export default "__VITE_ASSET__Bfct56jr__"